exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".welcome-app-sec{\r\n    margin-top: 3rem;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/welcome-page/app-coming/app-coming.component.css
// module id = ../../../../../src/app/welcome-page/app-coming/app-coming.component.css
// module chunks = main